import axios from 'axios'
const reportsUrl = '/api/reports'

export default class ReportService {
    // Get Reports all
    static getReports(searchTerm) {
        return new Promise(async (resolve, reject) => {
            try {
                let url = reportsUrl
                if (searchTerm) {
                    url += `?searchTerm=${searchTerm}`
                }

                let results = await axios.get(url)
                resolve(results.data)
            }
            catch (err) {
                reject(err)
            }
        })
    }

    // Get Reports paged
    static getReportsPaged(pageSize, requestPage) {
        return new Promise(async (resolve, reject) => {
            try {
                pageSize = pageSize || 20
                requestPage = requestPage || 1
                let url = `${reportsUrl}?paged=true&pageSize=${pageSize}&page=${requestPage}`                

                let results = await axios.get(url)
                resolve(results.data)
            }
            catch (err) {
                reject(err)
            }
        })
    }

    // Get Report by Job Reference
    static getReportByJobReference(jobReference) {
        return new Promise(async (resolve, reject) => {
            try {
                let result = await axios.get(`${reportsUrl}/${jobReference}`)
                resolve(result.data)
            } catch (err) {
                reject(err)                
            }
        })
    }

    // Build Report by Job Reference
    static buildReportByJobReference(jobReference) {
        return new Promise(async (resolve, reject) => {
            try {
                let result = await axios.post(`${reportsUrl}/${jobReference}/build`)
                resolve(result.data)
            } catch (err) {
                reject(err)                
            }
        })
    }

    // Update Report header
    static updateReportHeader(jobReference, updates) {
        return new Promise(async (resolve, reject) => {
            try {
                await axios.put(`${reportsUrl}/${jobReference}`, updates)
                resolve()
            } catch (err) {
                reject(err)                  
            }
        })
    }

    // Get report section media
    static getReportSectionMedia(jobReference, sectionNumber) {
        return new Promise(async (resolve, reject) => {
            try {
                let mediaUrl = `${reportsUrl}/${jobReference}/sections/${sectionNumber}/media`
                let results = await axios.get(mediaUrl)
                resolve(results.data)
            } catch (err) {
                reject(err)                
            }
        })
    }

    // Update media item
    static updateMediaItem(jobReference, sectionNumber, mediaId, updates) {
        return new Promise(async (resolve, reject) => {
            try {
                let mediaUrl = `${reportsUrl}/${jobReference}/sections/${sectionNumber}/media/${mediaId}`
                let result = await axios.put(mediaUrl, updates)
                resolve(result)
            } catch (err) {
                reject(err)                
            }
        })
    }

    // Update report section content
    static updateReportSectionContent(jobReference, sectionNumber, content) {
        return new Promise(async (resolve, reject) => {
            try {
                let url = `${reportsUrl}/${jobReference}/sections/${sectionNumber}`
                await axios.put(url, { content: content })
                resolve()
            } catch (err) {
                reject(err)                
            }
        })
    }

    // Create repair
    static createRepair(jobReference, sectionNumber, content) {
        return new Promise(async (resolve, reject) => {
            try {
                let url = `${reportsUrl}/${jobReference}/sections/${sectionNumber}/repairs`
                console.log('posting to', url)
                let result = await axios.post(url, { content: content })
                resolve(result.data)
            } catch (err) {
                reject(err)                
            }
        })
    }

    // Update repair
    static updateRepair(jobReference, sectionNumber, repairId, content) {
        return new Promise(async (resolve, reject) => {
            try {
                let url = `${reportsUrl}/${jobReference}/sections/${sectionNumber}/repairs/${repairId}`
                await axios.put(url, { content: content })
                resolve()
            } catch (err) {
                reject(err)                
            }
        })
    }

    // Delete repair
    static deleteRepair(jobReference, sectionNumber, repairId) {
        return new Promise(async (resolve, reject) => {
            try {
                let url = `${reportsUrl}/${jobReference}/sections/${sectionNumber}/repairs/${repairId}`
                await axios.delete(url)
                resolve()
            } catch (err) {
                reject(err)                
            }
        })
    }
}